import React from "react";
import clsx from "clsx";
import { useSelector } from "react-redux";
import TYPE from "../../../../../../../../constant/TYPE";
import Tip from "./Tip";

const Grammar = () => {

  const deviceInfo = useSelector( state => state.deviceInfo );

  return (
    <div className="mathExp-wrap">
      <div className="mathExp-inner">
        <div className={ clsx( 'mathExt', 'on', TYPE.DEVICE.PHONE === deviceInfo.type && 'add_pb' ) }>
          <Tip />
        </div>
      </div>
    </div>
  );

};

export default Grammar;
